import React, { useCallback, useMemo } from 'react';
import { cx } from '@emotion/css';
import styles from './FlyerAvailability.styles';
import { Tag, TitleSmallEmphasized } from '@/design-system';
import { FlyerSchool } from '@/graphql/types';
import { useReactiveVar } from '@apollo/client';
import { subscriptionsVar } from '@/graphql/state';
import { SchoolList } from '../SchoolList/SchoolList';

interface Props {
  schools: FlyerSchool[];
  disabled: boolean;
}

export const FlyerAvailability: React.FC<Props> = ({ schools, disabled }) => {
  const subscriptions = useReactiveVar(subscriptionsVar);
  const parentSchoolsAvailability = useMemo(
    () =>
      subscriptions.filter(subscription =>
        schools.some(school => school.schoolId.toString() === subscription.id)
      ),
    [subscriptions, schools]
  );

  const otherSchoolsAmount = useMemo(
    () => schools.length - parentSchoolsAvailability.length,
    [schools, parentSchoolsAvailability]
  );

  return (
    <div className={cx(styles.container, disabled && styles.disabled)}>
      <TitleSmallEmphasized>Flyer Availability</TitleSmallEmphasized>
      <SchoolList otherSchoolsAmount={otherSchoolsAmount} schools={parentSchoolsAvailability} />
    </div>
  );
};
